var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sb_doc_files p-3" },
    [
      _c("fileloader", {
        key: "file_loader_mem",
        attrs: {
          doc_type: "mobile_sb",
          doc_id: _vm.doc.id,
          trigger_load: _vm.file_trigger,
          can_del: true,
          "enable-preview": true,
          files: _vm.cur_files,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }